import React, { useState, useEffect } from "react";
import { HiOutlineRectangleGroup } from "react-icons/hi2";
import { RiLockPasswordLine, RiSecurePaymentLine } from "react-icons/ri";
import { useNavigate } from "react-router-dom";

const InitialSetupItem = () => {
    const navigate = useNavigate();
    const user_id = sessionStorage.getItem("user_id")
    const [userData, setUserData] = useState({})
    const [animateReset, setAnimateReset] = useState(false)

    const [selectedToggle, setSelectedToggle] = useState(3);

    const [hasPassword, setPassword] = useState(false);
    const [hasPayment, setPayments] = useState(false);
    const [hasProject, setProject] = useState(false);
    const [showSetup, setShowSetup] = useState(false)
    const [openSetup, setOpenSetup] = useState(true)

    const fetchUserData = async () => {
        setAnimateReset(true)
        try {
            const response = await fetch('https://backend.erioon.com/get_specific_data', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ user_id: user_id }),
            });

            if (!response.ok) {
                throw new Error('Failed to fetch user data');
            }

            const data = await response.json();
            setTimeout(() => {
                setAnimateReset(false)

            }, 800);
            setUserData(data);
            const projects = data.projects
            const payment_method = data.payment_method
            const password = data.personal_info.password

            if (projects) {
                setProject(true)
                // setSelectedToggle(1)
            }
            // if (password != null) {
            //     setPassword(true)
            //     setSelectedToggle(2)
            // }
            // if (payment_method) {
            //     setPayments(true)
            //     setSelectedToggle(3)
            // }

            if (password == null || !projects) {
                setShowSetup(true);
            } else {
                setShowSetup(false);
            }

        } catch (error) {
            setAnimateReset(false)
            console.error("Error fetching user data:", error);
        }
    };

    const toggleOpenSetup = () => {
        openSetup ? setOpenSetup(false) : setOpenSetup(true)
    }

    useEffect(() => {
        fetchUserData();
    }, []);


    if (!showSetup) {
        return null;
    } else {
        return (
            <div className={`initial_setup ? ${!openSetup ? "initial_setup_closed" : ""}`}>
                <p className="initial_setup_title">
                    <span >
                        {/* <i onClick={toggleOpenSetup} className={`fa-solid ${!openSetup ? "fa-chevron-up" : "fa-chevron-down"}`}></i> */}
                        Initial setup guide
                    </span>
                    <span className="reload_span" onClick={fetchUserData}>
                        <i className={`fa-solid fa-arrows-rotate ${animateReset ? "activated_animation" : ""}`}></i>
                    </span>
                </p>
                <div className="initial_setup_progress_bar">
                    <div
                        className="initial_setup_progress_fill"
                        style={{ width: `${((hasProject ? 1 : 0)) / 1 * 100}%` }}
                    ></div>
                </div>
                {/* <div className="initial_setup_items_cont">
                    <div className={`initial_setup_item ${selectedToggle === 1 ? "initial_setup_item_open" : "initial_setup_item_closed"}`}>
                        <p className="initial_setup_item_title" onClick={() => setSelectedToggle(1)}>
                            <span><RiLockPasswordLine /> New password</span> <i className="fa-solid fa-chevron-down"></i>
                        </p>
                        <div className="initial_setup_item_menu" onClick={() => navigate("/control_panel/profile")}>
                            <p>Create a new password <i className={`fa-regular ${hasPassword ? "fa-circle-check" : "fa-circle"}`}></i></p>
                        </div>
                    </div>
                </div> */}

                {/* <div className="initial_setup_items_cont">
                    <div className={`initial_setup_item ${selectedToggle === 2 ? "initial_setup_item_open" : "initial_setup_item_closed"}`}>
                        <p className="initial_setup_item_title" onClick={() => setSelectedToggle(2)}>
                            <span><RiSecurePaymentLine /> Payment method</span> <i className="fa-solid fa-chevron-down"></i>
                        </p>
                        <div className="initial_setup_item_menu" onClick={() => navigate("/control_panel/billing")}>
                            <p>Add a payment method <i className={`fa-regular ${hasPayment ? "fa-circle-check" : "fa-circle"}`}></i></p>
                        </div>
                    </div>
                </div> */}

                <div className="initial_setup_items_cont">
                    <div className={`initial_setup_item ${selectedToggle === 3 ? "initial_setup_item_open" : "initial_setup_item_closed"}`}>
                        <p className="initial_setup_item_title" onClick={() => setSelectedToggle(3)}>
                            <span><HiOutlineRectangleGroup /> First project</span> 
                            {/* <i className="fa-solid fa-chevron-down"></i> */}
                        </p>
                        <div className="initial_setup_item_menu" onClick={() => navigate("/control_panel/projects/new_project")}>
                            <p>Create your first project <i className={`fa-regular ${hasProject ? "fa-circle-check" : "fa-circle"}`}></i></p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }



};

export default InitialSetupItem;
